import positionDataFromJson from "../position/mapper";
import routeFeatureDataFromJson from "../route_feature/mapper";
import RouteData from "./data";

export default function routeDataFromJson(json) {
  return new RouteData(
    json.tag,
    json.data.map((datum) => positionDataFromJson(datum)),
    routeFeatureDataFromJson(json.features),
    json.creationDate
  );
}
